var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;} // eslint-disable-line max-lines

import Footer from "../../App/Footer";
import ShowIf from "../../App/ShowIf";
import { AttachmentsList } from "../../Attachments";
import { FileList } from "../../Attachments/components/FileList";
import { CreateConnectionPanel } from "../../Connections";
import { ConnectionsList } from "../../ConnectionsList";
import { connectionsChanged, deleteConnection } from "../../ConnectionsList/actions/actions";
import ContextMenu from "../../ContextMenu";
import { ShowSidepanelMenu } from "../../Entities/components/ShowSidepanelMenu";
import { Translate } from "../../I18N";

import { Icon as PropertyIcon, TemplateLabel } from "../../Layout";
import Tip from "../../Layout/Tip";
import { MetadataForm, ShowMetadata } from "../../Metadata";
import { RelationshipsFormButtons } from "../../Relationships";
import AddEntitiesPanel from "../../Relationships/components/AddEntities";
import RelationshipMetadata from "../../Relationships/components/RelationshipMetadata";
import { toggleOneUpFullEdit } from "../actions/actions";
import { OneUpEntityButtons } from "./OneUpEntityButtons";
import { OneUpSidePanel } from "./OneUpSidePanel";
import { OneUpTitleBar } from "./OneUpTitleBar";
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { TabContent, Tabs } from 'react-tabs-redux';
import { bindActionCreators } from 'redux';



import { Icon } from "../../UI";
import { selectEntity, selectMlThesauri, selectOneUpState } from "../common";

const defaultProps = {
  entity: {},
  relationships: Immutable.fromJS([]),
  templates: Immutable.fromJS([]),
  mlThesauri: [],
  oneUpState: {},
  tab: 'info',
  connectionsChanged: () => {},
  deleteConnection: (_reference) => {},
  toggleOneUpFullEdit: () => {}
};







export class OneUpEntityViewerBase extends Component


{






  constructor(props, context) {
    super(props, context);
    this.state = {
      panelOpen: true
    };
    this.closePanel = this.closePanel.bind(this);
    this.openPanel = this.openPanel.bind(this);
    this.deleteConnection = this.deleteConnection.bind(this);
  }

  deleteConnection(reference) {
    if (reference.sourceType !== 'metadata') {
      this.context.confirm({
        accept: () => {
          this.props.deleteConnection(reference);
        },
        title: 'Confirm delete connection',
        message: 'Are you sure you want to delete this connection?'
      });
    }
  }

  closePanel() {
    this.setState({ panelOpen: false });
  }

  openPanel() {
    this.setState({ panelOpen: true });
  }

  nonMlProps() {var _templates$find, _template$get;
    const { entity, mlThesauri, templates } = this.props;
    const template = (_templates$find =
    templates.find((tmpl) => tmpl.get('_id') === entity.template)) !== null && _templates$find !== void 0 ? _templates$find : Immutable.fromJS({});
    const properties = (_template$get =
    template.get('properties')) !== null && _template$get !== void 0 ? _template$get : Immutable.fromJS([]);
    return properties.
    filter((p) => {var _get;return !mlThesauri.includes((_get = p.get('content')) !== null && _get !== void 0 ? _get : '');}).
    map((p) => p.get('name')).
    toJS();
  }

  renderFullEditToggle() {
    const { oneUpState } = this.props;
    let onClick = () => this.props.toggleOneUpFullEdit();
    if (!oneUpState.fullEdit) {
      onClick = () =>
      this.context.confirm({
        accept: () => this.props.toggleOneUpFullEdit(),
        title: 'Keep this in mind if you want to edit:',
        message:
        "Changes can't be undone after saving. Changing text fields may invalidate the suggestions."
      });
    }
    return /*#__PURE__*/(
      _jsx("button", {
        type: "button",
        onClick: onClick,
        className:
        oneUpState.fullEdit ? 'btn btn-default btn-toggle-on' : 'btn btn-default btn-toggle-off' }, void 0, /*#__PURE__*/


      _jsx(Icon, { icon: oneUpState.fullEdit ? 'toggle-on' : 'toggle-off' }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Full edit mode"))));



  }

  render() {var _entity$template$toSt, _entity$template, _entity$template$toSt2, _entity$template2;
    const { entity, tab, relationships, oneUpState } = this.props;
    const { panelOpen } = this.state;
    const selectedTab = tab !== null && tab !== void 0 ? tab : 'info';

    return /*#__PURE__*/(
      _jsx("div", { className: "row flex" }, void 0, /*#__PURE__*/
      _jsx(Helmet, {}, void 0, /*#__PURE__*/
      _jsx("title", {}, void 0, entity.title ? entity.title : 'Entity')), /*#__PURE__*/

      _jsx("div", { className: "content-holder" }, void 0, /*#__PURE__*/
      _jsx("main", { className: "content-main" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "content-header content-header-entity" }, void 0, /*#__PURE__*/
      _jsx(OneUpTitleBar, {}),
      this.renderFullEditToggle()), /*#__PURE__*/

      _jsx("div", { className: "entity-viewer" }, void 0, /*#__PURE__*/
      _jsx(Tabs, { selectedTab: selectedTab }, void 0, /*#__PURE__*/
      _jsx(TabContent, {
        for:
        selectedTab === 'info' || selectedTab === 'attachments' ? selectedTab : 'none' }, void 0, /*#__PURE__*/


      _jsx("div", { className: "entity-metadata" }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: oneUpState.fullEdit }, void 0, /*#__PURE__*/
      _jsx(MetadataForm, {
        id: "fullEditMetadataForm",
        model: "entityView.entityForm",
        templateId: (_entity$template$toSt = (_entity$template = entity.template) === null || _entity$template === void 0 ? void 0 : _entity$template.toString()) !== null && _entity$template$toSt !== void 0 ? _entity$template$toSt : '',
        showSubset: [...this.nonMlProps(), 'title'],
        version: "OneUp" })), /*#__PURE__*/


      _jsx(ShowIf, { if: !oneUpState.fullEdit }, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: "content-header-title" }, void 0, /*#__PURE__*/
      _jsx(PropertyIcon, {
        className: "item-icon item-icon-center",
        data: entity.icon,
        size: "sm" }), /*#__PURE__*/

      _jsx("h1", { className: "item-name" }, void 0, entity.title), /*#__PURE__*/
      _jsx(TemplateLabel, { template: (_entity$template$toSt2 = (_entity$template2 = entity.template) === null || _entity$template2 === void 0 ? void 0 : _entity$template2.toString()) !== null && _entity$template$toSt2 !== void 0 ? _entity$template$toSt2 : '' }),
      entity.published ?
      '' : /*#__PURE__*/

      _jsx(Tip, { icon: "eye-slash" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This entity is not public."))), /*#__PURE__*/



      _jsx(ShowMetadata, {
        relationships: relationships,
        entity: entity,
        showTitle: false,
        showType: false,
        showSubset: this.nonMlProps() }), /*#__PURE__*/

      _jsx(FileList, { files: entity.documents, entity: entity }), /*#__PURE__*/
      _jsx(AttachmentsList, {
        attachments: entity.attachments,
        parentId: entity._id,
        parentSharedId: entity.sharedId,
        isDocumentAttachments: Boolean(entity.file),
        entityView: true,
        processed: entity.processed }))))), /*#__PURE__*/





      _jsx(TabContent, { for: "connections" }, void 0, /*#__PURE__*/
      _jsx(ConnectionsList, {
        deleteConnection: this.deleteConnection,
        searchCentered: true,
        hideFooter: true })))), /*#__PURE__*/




      _jsx(ShowIf, { if: selectedTab === 'connections' }, void 0, /*#__PURE__*/
      _jsx("div", { className: "content-footer" }, void 0, /*#__PURE__*/
      _jsx(RelationshipsFormButtons, {}))), /*#__PURE__*/


      _jsx(ShowIf, { if: selectedTab !== 'connections' }, void 0, /*#__PURE__*/
      _jsx(OneUpEntityButtons, {
        isLast: oneUpState.indexInDocs === oneUpState.totalDocs - 1,
        thesaurusName: oneUpState.reviewThesaurusValues[0] })), /*#__PURE__*/


      _jsx(ContextMenu, {
        align: "bottom",
        overrideShow: true,
        show: !panelOpen,
        className: "show-info-sidepanel-context-menu" }, void 0, /*#__PURE__*/

      _jsx(ShowSidepanelMenu, {
        className: "show-info-sidepanel-menu",
        panelIsOpen: panelOpen,
        openPanel: this.openPanel }))), /*#__PURE__*/



      _jsx(OneUpSidePanel, { panelOpen: panelOpen, closePanel: this.closePanel }), /*#__PURE__*/
      _jsx(CreateConnectionPanel, {
        className: "entity-create-connection-panel",
        containerId: entity.sharedId,
        onCreate: this.props.connectionsChanged }), /*#__PURE__*/

      _jsx(AddEntitiesPanel, {}), /*#__PURE__*/
      _jsx(RelationshipMetadata, {})), /*#__PURE__*/

      _jsx(Footer, {})));


  }
}_defineProperty(OneUpEntityViewerBase, "defaultProps", defaultProps);_defineProperty(OneUpEntityViewerBase, "contextTypes", { confirm: PropTypes.func });

const mapStateToProps = (state) => {var _selectOneUpState;return {
    entity: selectEntity(state),
    relationships: state.entityView.entity.get('relationships'),
    tab: state.entityView.uiState.get('tab'),
    oneUpState: (_selectOneUpState = selectOneUpState(state)) !== null && _selectOneUpState !== void 0 ? _selectOneUpState : {},
    templates: state.templates,
    mlThesauri: selectMlThesauri(state)
  };};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
  {
    connectionsChanged,
    deleteConnection,
    toggleOneUpFullEdit
  },
  dispatch);

}

export const OneUpEntityViewer = connect(
mapStateToProps,
mapDispatchToProps)(
OneUpEntityViewerBase);